export interface PrescriptionLineContent {
  PrescriptionDate: string
  Prescriber: Prescriber
  Patient: Patient
  Medication: Medication
  MedicineId?: string
}
export interface Prescriber {
  PrescriberCode: string | null
  PrescriberType: string
  Name: string
}
export interface Patient {
  Sex: string
  DateOfBirth: string
  Initials?: string
  Firstname?: string
  Lastname: string
  Address: Address
  InsurerCode?: string
  InsurancePolicyNumber?: string
  Bsn: string
}
export interface Address {
  Street: string
  HouseNumber: string
  City: string
  PostalCode: string
}
export interface Medication {
  AmountDelivered: number
  Name: string
  Code: string
  WciaDosageUnit?: string
  CodeType: CodeType
  WciaCode: string
  WciaReadable: string
  PrescriberNote: string
  StartDate: string
  EndDate: string
  AuthorisationDate: string
  UnitAbbreviation?: string
  AllowedIterations?: number
  AuthorisedAmountPerIteration?: number
  Reason?: string | null
}

export enum CodeType {
  KNMP = 'KNMP',
  KNMPROD = 'KNMPROD',
  GPK = 'GPK',
  HPK = 'HPK',
  PRK = 'PRK',
}
